/**
 * Video Player — Magnific Popup para vídeos
 * Requer jQuery + Magnific Popup carregados via CDN (enqueue no functions.php)
 */

// Aceita watch?v=, youtu.be/, /embed/, /v/, /shorts/ e /live/ — e ignora
// parâmetros extras (?si=, &t=, &list=), que quebravam o ID do embed.
const YOUTUBE_ID_RE = /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;

const YOUTUBE_EMBED_SRC = 'https://www.youtube.com/embed/%id%?autoplay=1&rel=0&playsinline=1';

function youtubeId( url ) {
	const m = String( url ).match( YOUTUBE_ID_RE );
	return m ? m[1] : null;
}

export function initVideoPlayer() {
	const links = document.querySelectorAll('[data-video-popup]');
	if ( ! links.length ) return;

	// Aguarda jQuery + Magnific Popup estarem disponíveis
	const waitForMfp = () => {
		if ( typeof jQuery !== 'undefined' && jQuery.fn.magnificPopup ) {
			jQuery('[data-video-popup]').magnificPopup({
				type: 'iframe',
				mainClass: 'mfp-fade',
				removalDelay: 300,
				preloader: true,
				fixedContentPos: true,
				iframe: {
					patterns: {
						youtube: {
							index: 'youtube.com/',
							id: youtubeId,
							src: YOUTUBE_EMBED_SRC
						},
						// Links curtos (youtu.be/ID) não casam com o index acima.
						youtubeShort: {
							index: 'youtu.be/',
							id: youtubeId,
							src: YOUTUBE_EMBED_SRC
						},
						vimeo: {
							index: 'vimeo.com/',
							id: function( url ) {
								const m = url.match( /vimeo\.com\/(\d+)/ );
								return m ? m[1] : null;
							},
							src: 'https://player.vimeo.com/video/%id%?autoplay=1'
						}
					},
					// referrerpolicy é obrigatório: sem Referer o YouTube não
					// identifica o site que está embedando e devolve
					// "Erro 153 — Erro de configuração do player de vídeo".
					markup:
						'<div class="mfp-iframe-scaler">' +
							'<div class="mfp-close"></div>' +
							'<iframe class="mfp-iframe" frameborder="0" allowfullscreen ' +
								'referrerpolicy="strict-origin-when-cross-origin" ' +
								'allow="autoplay; fullscreen; encrypted-media; picture-in-picture"></iframe>' +
						'</div>'
				}
			});
		} else {
			setTimeout( waitForMfp, 100 );
		}
	};

	waitForMfp();
}
